import type { GetStreamingInfo200DrmType } from './getStreamingInfo200DrmType';

/**
 * DRM 정보 (있는 경우)
 */
export type GetStreamingInfo200Drm = {
  licenseUrl?: string;
  type?: GetStreamingInfo200DrmType;
};
